import {
  GET_HOMEPAGE,
  GET_HOMEPAGE_FAIL,
  GET_HOMEPAGE_SUCCESS,
  GET_MOSTLY_VIEW,
  GET_MOSTLY_VIEW_FAIL,
  GET_MOSTLY_VIEW_SUCCESS,
  GET_LATEST,
  GET_LATEST_SUCCESS,
  GET_LATEST_FAIL,
  GET_TOP_COLLECTIONS,
  GET_TOP_COLLECTIONS_SUCCESS,
  GET_TOP_COLLECTIONS_FAIL,
  GET_EXPLORE,
  GET_EXPLORE_SUCCESS,
  GET_EXPLORE_FAIL,
  GET_SECONDRY_SALE,
  GET_SECONDRY_SALE_SUCCESS,
  GET_SECONDRY_SALE_FAIL,
  POST_FOLLOW,
  POST_FOLLOW_SUCCESS,
  POST_FOLLOW_FAIL,
  GET_FOLLOW,
  GET_FOLLOW_SUCCESS,
  GET_FOLLOW_FAIL,
  GET_BLOGS,
  GET_BLOGS_SUCCESS,
  GET_BLOGS_FAIL,
  GET_BLOGS_BY_ID,
  GET_BLOGS_BY_ID_SUCCESS,
  GET_BLOGS_BY_ID_FAIL,
} from "./actionTypes";

/* Get Homepage */
export const getHomepage = (data, callback) => ({
  type: GET_HOMEPAGE,
  payload: { data, callback },
});

export const getHomepageFail = (error) => ({
  type: GET_HOMEPAGE_FAIL,
  payload: error,
});

export const getHomepageSuccess = (data) => ({
  type: GET_HOMEPAGE_SUCCESS,
  payload: data,
});
/* Get Homepage END */

/* Get Mostly Viewed */
export const getMostlyView = (data, callback) => ({
  type: GET_MOSTLY_VIEW,
  payload: { data, callback },
});

export const getMostlyViewFail = (error) => ({
  type: GET_MOSTLY_VIEW_FAIL,
  payload: error,
});

export const getMostlyViewSuccess = (data) => ({
  type: GET_MOSTLY_VIEW_SUCCESS,
  payload: data,
});
/* Get Mostly Viewed END */

/* Get Latest NFT */
export const getLatest = (data, callback) => ({
  type: GET_LATEST,
  payload: { data, callback },
});

export const getLatestFail = (error) => ({
  type: GET_LATEST_FAIL,
  payload: error,
});

export const getLatestSuccess = (data) => ({
  type: GET_LATEST_SUCCESS,
  payload: data,
});
/* Get Latest NFT END */

/* Get Top Collections */
export const getTopCollections = (data, callback) => ({
  type: GET_TOP_COLLECTIONS,
  payload: { data, callback },
});

export const getTopCollectionsFail = (error) => ({
  type: GET_TOP_COLLECTIONS_FAIL,
  payload: error,
});

export const getTopCollectionsSuccess = (data) => ({
  type: GET_TOP_COLLECTIONS_SUCCESS,
  payload: data,
});
/* Get Top Collections END */

/* Get Explore */
export const getExplore = (data, callback) => ({
  type: GET_EXPLORE,
  payload: { data, callback },
});

export const getExploreFail = (error) => ({
  type: GET_EXPLORE_FAIL,
  payload: error,
});

export const getExploreSuccess = (data) => ({
  type: GET_EXPLORE_SUCCESS,
  payload: data,
});
/* Get Explore END */

/* Get Secondry Sale NFT's */
export const getSecondrySale = (data, callback) => ({
  type: GET_SECONDRY_SALE,
  payload: { data, callback },
});

export const getSecondrySaleFail = (error) => ({
  type: GET_SECONDRY_SALE_FAIL,
  payload: error,
});

export const getSecondrySaleSuccess = (data) => ({
  type: GET_SECONDRY_SALE_SUCCESS,
  payload: data,
});
/* Get Secondry Sale NFT's END */
/* post follow */
export const postFollow = (data, callback) => ({
  type: POST_FOLLOW,
  payload: { data, callback },
});

export const postFollowFail = (error) => ({
  type: POST_FOLLOW_FAIL,
  payload: error,
});

export const postFollowSuccess = (data) => ({
  type: POST_FOLLOW_SUCCESS,
  payload: data,
});
export const getFollow = (data, callback) => ({
  type: GET_FOLLOW,
  payload: { data, callback },
});

export const getFollowFail = (error) => ({
  type: GET_FOLLOW_FAIL,
  payload: error,
});

export const getFollowSuccess = (data) => ({
  type: GET_FOLLOW_SUCCESS,
  payload: data,
});
/* post follow END */

//blog
export const getBlogs = (data, callback) => ({
  type: GET_BLOGS,
  payload: { data, callback },
});

export const getBlogsFail = (error) => ({
  type: GET_BLOGS_FAIL,
  payload: error,
});

export const getBlogsSuccess = (data) => ({
  type: GET_BLOGS_SUCCESS,
  payload: data,
});

//blog
export const getBlogsById = (data, callback) => ({
  type: GET_BLOGS_BY_ID,
  payload: { data, callback },
});

export const getBlogsByIdFail = (error) => ({
  type: GET_BLOGS_BY_ID_FAIL,
  payload: error,
});

export const getBlogsByIdSuccess = (data) => ({
  type: GET_BLOGS_BY_ID_SUCCESS,
  payload: data,
});
